module.exports = __webpack_public_path__ + "static/img/048_TO8_1571_og.d41e976.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/048_TO8_1571_og.jpg
// module id = kwtQ
// module chunks = 0